const indexItems = [
  { label: '动作大片', icon: 'ri-sword-line', count: '328部' },
  { label: '喜剧合集', icon: 'ri-emotion-laugh-line', count: '256部' },
  { label: '科幻巨制', icon: 'ri-rocket-line', count: '189部' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '215部' },
  { label: '爱情文艺', icon: 'ri-heart-line', count: '302部' },
  { label: '恐怖惊悚', icon: 'ri-ghost-line', count: '147部' },
  { label: '动画动漫', icon: 'ri-palette-line', count: '421部' },
  { label: '纪录写实', icon: 'ri-camera-lens-line', count: '193部' },
  { label: '综艺娱乐', icon: 'ri-mv-line', count: '568部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            主题分类
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            内容分类索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型快速浏览海量高清视频资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 max-w-3xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#cards"
              className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-200 transition-colors shrink-0">
                <i className={`${item.icon} text-primary-600 text-base`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 whitespace-nowrap">{item.label}</h3>
                <p className="text-xs text-foreground-400">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}